import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import YouTubeIcon from '../../HOME/SVG/YouTubeIcon';
import { showLeaderboards, requestSurrender, requestResetStats } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { pause } from '../REDUX/actions';
import { YOUTUBE_NM } from '../const';

const Toolbar = props => {
  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      props.requestSurrender(true);
      props.requestResetStats(false);
    }
  };

  const handleLeaders = () => {
    props.pause(true);
    props.hideOptions();
    props.showLeaderboards();
  };

  const canSurrender = () => {
    return props.level > 1 || (props.stack || []).length;
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));

  const styles = {
    button: { marginLeft: margin, marginRight: margin },
  };

  return (
    <div className="toolbar">
      <span className={`toolbar-button ${canSurrender(props) ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        <RestartIcon width="36" />
      </span>
      {props.practice ? (
        <span className="toolbar-button" style={styles.button}>
          <a href={YOUTUBE_NM} target="_blank" rel="noopener noreferrer">
            <YouTubeIcon width="36" outline />
          </a>
        </span>
      ) : (
        <span className="toolbar-button" style={styles.button} onClick={handleLeaders}>
          <TrophyIcon width="36" />
        </span>
      )}
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" />
      </span>
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender, showLeaderboards, pause }
)(Toolbar);
